<div class="mct-flex mct-row mct-wrap mct-flex-lt-lg mct-col-lt-lg mct-nowrap-lt-lg mct-gap-20"
  *ngIf="notifications"
  
  
  
  [ngClass]="{ 'notifications-container': notifications.length > 0 }"
>
  <div *ngFor="let notification of notifications" class="notification mct-justify-center mct-items-stretch mct-flex-1-1-0"  >
    <div *ngIf="notification.NotificationType == 0" id="noRelations">
      {{ 'profiles.view.notifications.no-relations' | translate | ucfirst }}&nbsp;
      <a (click)="addRelationship()">{{ 'profiles.view.notifications.click-here' | translate | ucfirst }}</a>
      &nbsp;{{ 'profiles.view.notifications.to-add-one' | translate }}
    </div>
    <div *ngIf="notification.NotificationType == 1" id="noDuesInvoices">
      {{ 'profiles.view.notifications.no-dues-invoices' | translate | ucfirst }}&nbsp;
      <a [routerLink]="newInvoiceUrl" [queryParams]="{ profileId: profileId }">{{
        'profiles.view.notifications.click-here' | translate | ucfirst
      }}</a>
      &nbsp;{{ 'profiles.view.notifications.to-add-one' | translate }}
    </div>
  </div>
</div>
